export const JP_COUNTRY_ID = 1
